import { useQuery } from "@tanstack/react-query";
import AdminService from "../../services/AdminService";

const useOffices = (options = {}) => {
  return useQuery({
    ...options,
    queryKey: ["offices"],
    initialData: [],
    queryFn: async () => {
      const res = await AdminService.getOffices();
      return res.offices;
    },
  });
};

export default useOffices;
